import { TraceKeyMode } from '@stratumn/studio-shared';
import { Lock, type LucideIcon, PencilRuler, Sparkles } from 'lucide-react';

export const traceKeyModeDataMap: Record<
  TraceKeyMode,
  {
    label: string;
    icon: LucideIcon;
  }
> = {
  [TraceKeyMode.Follow]: {
    label: 'Follow',
    icon: Sparkles
  },
  [TraceKeyMode.Free]: {
    label: 'Custom',
    icon: PencilRuler
  },
  [TraceKeyMode.Locked]: {
    label: 'Locked',
    icon: Lock
  }
};
